"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeader = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _icons = require("@chakra-ui/icons");
var _react = require("@chakra-ui/react");
var _nextI18next = require("next-i18next");
var _react2 = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _helpers = require("../helpers");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TableHeader = _ref => {
  var {
    currentDates,
    sortedByDate,
    handleDateSort,
    handleScrollLeft,
    handleScrollRight,
    isScrollLeftDisabled,
    isScrollRightDisabled = false,
    isLoading = false,
    isMobile,
    isSmallerThanSm,
    tableHeaderRef,
    handleSortToggle,
    locale = 'en-GB'
  } = _ref;
  var {
    t
  } = (0, _nextI18next.useTranslation)();
  return (0, _jsxRuntime.jsx)(_react.Thead, _objectSpread(_objectSpread({}, styles.thead), {}, {
    "data-testid": "hotel-price-table-header",
    ref: tableHeaderRef,
    children: (0, _jsxRuntime.jsxs)(_react.Tr, {
      "data-testid": "hotel-price-table-header-row-dates",
      children: [!isMobile && (0, _jsxRuntime.jsx)(_react.Th, _objectSpread(_objectSpread({}, styles.hotelNameHeader), {}, {
        "data-testid": "hotel-name-header",
        children: handleSortToggle && (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.desktopSortButton), {}, {
          as: "button",
          onClick: handleSortToggle,
          color: _constants.THEME_COLORS.sortTextColor,
          children: (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [(0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.sortText), {}, {
              as: "span",
              children: t('priceFinder.sortByDistance')
            })), (0, _jsxRuntime.jsx)(_react.Icon, {
              "aria-label": "Sorted by distance ascending",
              color: sortedByDate ? _constants.THEME_COLORS.disabledColor : _constants.THEME_COLORS.primaryColor,
              as: _icons.ArrowDownIcon,
              boxSize: 4
            })]
          })
        }))
      })), (0, _jsxRuntime.jsx)(_react.Th, _objectSpread(_objectSpread({}, styles.scrollHeader), {}, {
        w: isMobile ? '24px' : '40px',
        "data-testid": "scroll-left-header",
        children: !isScrollLeftDisabled && (0, _jsxRuntime.jsx)(_react.IconButton, _objectSpread(_objectSpread({}, isLoading ? styles.disabledScrollButton : styles.scrollButton), {}, {
          "data-testid": "scroll-left-button",
          "aria-label": "View previous 7 days",
          icon: (0, _jsxRuntime.jsx)(_icons.ChevronLeftIcon, {
            boxSize: "6"
          }),
          onClick: handleScrollLeft,
          size: "xs",
          variant: "ghost",
          isDisabled: isLoading
        }))
      })), currentDates.map(date => {
        var {
          weekday,
          day,
          month
        } = (0, _helpers.formatDate)(date, {
          isSmallerThanSm,
          locale
        });
        var isCurrentSort = sortedByDate === date;
        var isTodayDate = (0, _helpers.isToday)(date);
        return (0, _react2.createElement)(_react.Th, _objectSpread(_objectSpread({}, styles.dateHeader), {}, {
          key: date,
          "data-testid": "date-header-".concat(date),
          onClick: () => handleDateSort(date),
          onKeyDown: e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleDateSort(date);
            }
          },
          bg: isCurrentSort ? _constants.THEME_COLORS.sortedBg : isTodayDate ? 'blue.50' : 'transparent',
          _hover: {
            bg: isCurrentSort ? _constants.THEME_COLORS.sortedHoverBg : _constants.THEME_COLORS.hoverBg
          },
          "aria-label": "Sort by price for ".concat(weekday, " ").concat(day).concat(isCurrentSort ? ' (currently sorted)' : ''),
          minW: isMobile ? '28px' : '82.55px',
          w: isMobile ? '28px' : 'full',
          fontSize: {
            base: 'xs',
            md: 'sm'
          }
        }), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.weekdayText), {}, {
          color: isCurrentSort ? _constants.THEME_COLORS.primaryColor : '#58595B',
          sx: {
            'th:hover &': {
              color: _constants.THEME_COLORS.primaryColor
            }
          },
          children: weekday
        })), (0, _jsxRuntime.jsxs)(_react.Box, _objectSpread(_objectSpread({}, isMobile ? styles.dayContainerMobile : styles.dayContainerDesktop), {}, {
          color: isCurrentSort ? _constants.THEME_COLORS.primaryColor : 'black',
          sx: {
            'th:hover &': {
              color: _constants.THEME_COLORS.primaryColor
            }
          },
          children: [(0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread(_objectSpread({}, styles.dayNumber), month && _objectSpread({}, styles.monthText)), {}, {
            children: month ? "".concat(day, " ").concat(month) : day
          })), (0, _jsxRuntime.jsx)(_react.Icon, {
            "aria-label": "Sorted by price ascending",
            color: isCurrentSort ? _constants.THEME_COLORS.primaryColor : _constants.THEME_COLORS.borderColor,
            as: _icons.ArrowDownIcon,
            boxSize: 4
          })]
        })), isTodayDate && (0, _jsxRuntime.jsx)(_react.Box, _objectSpread({}, styles.todayIndicator)));
      }), (0, _jsxRuntime.jsx)(_react.Th, _objectSpread(_objectSpread({}, styles.scrollHeader), {}, {
        w: isMobile ? '24px' : '40px',
        "data-testid": "scroll-right-header",
        children: !isScrollRightDisabled && (0, _jsxRuntime.jsx)(_react.IconButton, _objectSpread(_objectSpread({}, isLoading ? styles.disabledScrollButton : styles.scrollButton), {}, {
          "data-testid": "scroll-right-button",
          "aria-label": "View next 7 days",
          icon: (0, _jsxRuntime.jsx)(_icons.ChevronRightIcon, {
            boxSize: "6"
          }),
          onClick: handleScrollRight,
          size: "xs",
          variant: "ghost",
          isDisabled: isLoading
        }))
      }))]
    })
  }));
};
exports.TableHeader = TableHeader;
var styles = {
  thead: {
    bg: _constants.THEME_COLORS.headerBg,
    borderColor: _constants.THEME_COLORS.borderColor
  },
  hotelNameHeader: {
    scope: 'col',
    w: '50%',
    borderColor: _constants.THEME_COLORS.borderColor,
    position: 'relative',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontFamily: 'body'
  },
  scrollHeader: {
    p: 0,
    borderColor: _constants.THEME_COLORS.borderColor
  },
  dateHeader: {
    scope: 'col',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    tabIndex: 0,
    role: 'button',
    position: 'relative',
    borderColor: _constants.THEME_COLORS.borderColor,
    textTransform: 'capitalize',
    fontFamily: 'body',
    padding: '15px 0'
  },
  weekdayText: {
    fontSize: {
      base: '13px',
      md: '14px'
    },
    fontWeight: {
      base: 400,
      md: 600
    },
    fontFamily: 'body',
    lineHeight: '1'
  },
  dayContainerMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0,
    fontWeight: 600,
    textAlign: 'center',
    minHeight: '30px',
    fontFamily: 'body'
  },
  dayContainerDesktop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    fontWeight: 600,
    textAlign: 'center',
    fontFamily: 'body',
    flexDirection: 'row'
  },
  dayNumber: {
    fontSize: '16px',
    lineHeight: '1.2',
    fontFamily: 'body',
    height: '32px',
    alignContent: 'center'
  },
  monthText: {
    fontSize: {
      base: '13px',
      xs: '16px'
    },
    lineHeight: {
      base: '14px',
      md: '1.2'
    },
    fontWeight: 700
  },
  sortArrow: {
    fontSize: {
      base: 'xs',
      md: 'md'
    },
    fontWeight: 'bold',
    fontFamily: 'system-ui'
  },
  todayIndicator: {
    position: 'absolute',
    top: '2px',
    right: '2px',
    w: '6px',
    h: '6px',
    bg: 'blue.500',
    borderRadius: 'full'
  },
  desktopSortButton: {
    fontWeight: 500,
    fontSize: '13px',
    cursor: 'pointer',
    bg: 'transparent',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    mx: '0',
    lineHeight: '1.5',
    fontFamily: 'body',
    _hover: {
      textDecoration: 'none'
    }
  },
  sortText: {
    textDecoration: 'underline',
    fontSize: '14px',
    fontWeight: 500
  },
  sortArrowIcon: {
    color: _constants.THEME_COLORS.primaryColor,
    fontSize: 'sm',
    fontFamily: 'system-ui'
  },
  scrollButton: {
    transition: 'all 0.2s ease',
    borderRadius: 'full',
    color: '#58595B',
    textAlign: 'center',
    _hover: {
      bg: _constants.THEME_COLORS.primaryColor,
      color: 'white',
      borderRadius: 'full',
      height: '32px',
      width: '32px'
    }
  },
  disabledScrollButton: {
    opacity: 0.4,
    transition: 'all 0.2s ease',
    borderRadius: 'full',
    _hover: {}
  }
};